import { faCheckCircle, faClock, faFileSlash, faPencil } from '@fortawesome/pro-light-svg-icons'
import { DisplayStatus } from '../../../baseComponents/Displays/DisplayStatus'
import { RowData } from '../../../baseComponents/TwinTable/types'
import TwinToolTip from '../../../baseComponents/TwinToolTip'
import useTwinTranslation from '../../../utils/hooks/useTwinTranslation'
import { BuyTagsPayload } from '../../../utils/reducers/buys/buyTags'

interface RenderBuyTagsProps {
    allRowData: RowData
    buyTags: BuyTagsPayload
}

export const RenderBuyTags: React.FC<RenderBuyTagsProps> = ({ allRowData, buyTags }) => {
    if (!allRowData?.OrderTagRels?.length) {
        return <div>--</div>
    }
    const renderThis: JSX.Element[] = []
    const shortVersion = allRowData.OrderTagRels?.length > Math.floor(allRowData['_myColumnWidth'] / 80)
    for (const key in allRowData.OrderTagRels) {
        const tagId = allRowData.OrderTagRels[key].OrderTagId
        const tag = buyTags?.[tagId]
        const id = 'Buy_' + allRowData?.id + '_' + tagId
        renderThis.push(
            <div className='max-w-full'>
                <TwinToolTip id={id} place='top' content={tag?.name} />
                <div className='flex items-center ' data-tooltip-id={id}>
                    <div className={'rounded-full h-10 w-10 border border-gray-D6 min-h-10 min-w-10 '} style={{ backgroundColor: tag?.color }} />
                    {!shortVersion ? <span className='ml-5 twin_elipsis'>{tag?.name}</span> : null}
                </div>
            </div>
        )
    }
    return (
        <div className={'flex items-center flex-wrap max-w-full ' + (shortVersion ? 'gap-x-5' : 'gap-x-10')}>
            {renderThis}
        </div>
    )
}


interface RenderBuyStatusProps {
    value: string
}

export const RenderBuyStatus: React.FC<RenderBuyStatusProps> = ({ value }) => {
    const parsedValue = parseInt(value)
    const { t } = useTwinTranslation()
    if (parsedValue === 0) {
        return <DisplayStatus icon={faPencil} colorText='text-gray-97' text={t('draft', 'Borrador')} />
    } else if (parsedValue === 1) {
        return <DisplayStatus icon={faClock} colorText='text-orange-DE' text={t('pending', 'En espera')} />
    } else if (parsedValue === 3) {
        return <DisplayStatus icon={faFileSlash} colorText='text-red-BA' text={t('cancelled', 'Cancelado')} />
    }
    return <DisplayStatus icon={faCheckCircle} colorText='text-green-43' text={t('processed', 'Procesado')} />

}